import { Card, CardContent, List } from "@/components/ui";
import { AUTHORITIES } from "@/config/constants";
import { useAppSelector } from "@/config/store";
import { hasAnyAuthority } from "@/shared/auth/private-route";
import { IEdoCourseMaterial } from "@/shared/model/edo-course-material.model";
import { AuthenticationState } from "@/shared/reducers/authentication";
import axios from "axios";
import { useEffect, useState } from "react";
import CourseMaterial from "./CourseMaterial";

const CourseMaterials = () => {
  const { account } = useAppSelector<AuthenticationState>((state) => state.authentication);
  const isStudent = hasAnyAuthority(account?.roles ?? [], [AUTHORITIES.ROLE_STUDENT]);
  const [courseMaterials, setCourseMaterials] = useState<IEdoCourseMaterial[]>([]);

  const getLastCourseMaterials = async () => {
    if (!account?.id || !isStudent) return;
    const response = await axios.get<{ data: IEdoCourseMaterial[] }>(
      `/students/${account.id}/course-materials`,
      {
        params: {
          page: 0,
          limit: 5,
          sortBy: "dataCreation,desc",
        },
      }
    );
    setCourseMaterials(response.data.data ?? []);
  };

  useEffect(() => {
    getLastCourseMaterials();
  }, [account?.id, isStudent]);

  if (!isStudent) return null;

  return (
    <Card className="overflow-hidden rounded-3xl border border-[var(--color-mockup-border)] p-0 shadow-card">
      <div className="border-b border-[var(--color-mockup-border)] bg-[var(--color-surface-secondary)]/30 px-5 py-3">
        <p className="text-sm font-heading font-bold text-[var(--color-mockup-text)]">
          Materiale aggiunto di recente
        </p>
      </div>
      <CardContent className="p-0 last:pb-0">
        {courseMaterials.length > 0 ? (
          <List className="divide-y divide-[var(--color-mockup-border)]">
            {courseMaterials.map((courseMaterial) => (
              <CourseMaterial
                key={courseMaterial.id}
                courseMaterial={courseMaterial}
                compact
              />
            ))}
          </List>
        ) : (
          <div className="px-5 py-4 text-center text-sm text-[var(--color-mockup-text-mid)]">
            Nessun materiale recente
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default CourseMaterials;
